export const notify = {
  success: async (title: string) => {
    const { default: Swal } = await import('sweetalert2');
    return Swal.fire({
      icon: 'success',
      title,
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000,
    });
  },
  error: async (title: string) => {
    const { default: Swal } = await import('sweetalert2');
    return Swal.fire({
      icon: 'error',
      title,
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000,
    });
  },
  info: async (title: string) => {
    const { default: Swal } = await import('sweetalert2');
    return Swal.fire({
      icon: 'info',
      title,
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000,
    });
  },
  warning: async (title: string) => {
    const { default: Swal } = await import('sweetalert2');
    return Swal.fire({
      icon: 'warning',
      title,
      toast: true,
      position: 'bottom-end',
      showConfirmButton: false,
      timer: 3000,
    });
  },
};
